
export const SHOP_GOODS_LIST_KEY = "SHOP_GOODS_LIST_KEY"

export const DEVICE_ID = 'DEVICE_ID';//客户端类型 
export const DEPT_NAME = 'DEPT_NAME';//叫号类型 
export const VPN_NAME = 'VPN_NAME'; //门店名称
export const VPN_ID = 'VPN_ID'; //门店编号
export const CURRENT_VPN = 'CURRENT_VPN'; //门店所有信息
export const ALL_VPN_LIST = 'ALL_VPN_LIST'; //门店所有信息

export const OPERATOR_ID = 'OPERATOR_ID'; //设备名称
export const OPERATOR_PWD = 'OPERATOR_PWD'; //设备名称
export const OPERATOR_NAME = 'OPERATOR_NAME'; //设备名称
export const OPERATOR_PositionName = 'OPERATOR_PositionName'; //设备名称
export const OPERATOR_SEX = 'OPERATOR_SEX'; //设备名称
export const FUNCTION_STRING = 'FUNCTION_STRING'; //权限值
export const TxtPadPosSwitchParlorcode = 'txtPadPosSwitchParlorcode'; //部门
export const DEFAULT_JISHI_CLOCK_TYPEID = 'DEFAULT_JISHI_CLOCK_TYPEID';
export const DEFAULT_JISHI_CLOCK_TYPEID_CONFIG = 'DEFAULT_JISHI_CLOCK_TYPEID_CONFIG';
export const GUEST_ROOM_DEPT_NAME = 'GUEST_ROOM_DEPT_NAME';



import { handleLocalStorage } from '@/utils'
import { $http, requestOfGet, requestOfPost, requestOfPut } from '@/utils/http'
const baseUrl = 'wechath5/zh-cn/v1/'
export function login(param) { // 登录
	return requestOfPost(`${baseUrl}report/gv5/login`, param)
}

export function employeeSearch(param) { // 权限

	return requestOfPost(`${baseUrl}report/gv5/employee/search`, param)
}
export function sysparaSearch(param) { // 部门
	return requestOfPost(`${baseUrl}report/gv5/syspara/search`, param)
}

export function getdashboard(param) { // 报表

	return requestOfPost(`${baseUrl}report/gv5/dashboard`, param)
}

export function setUserWxAuth(param) {
	return requestOfPut(`${baseUrl}permission/save`, param)
}

//检查老版报表是不是已经有权限
export function checkPermissionCheck() {
	return requestOfGet(`${baseUrl}/permission/check/1`)
}

export function getdashboardSetting() { // 报表显示设置
	const result = [{
			category: '营业分析',
			categoryId: 1,
			childen: [{
					name: '全部',
					seleted: true,
					Id: 'all'
				},
				{
					name: '营业额',
					seleted: true,
					Id: 'BusinessAmount'
				},
				{
					name: '已收(元)',
					seleted: true,
					Id: 'SettledAmount'
				},
				{
					name: '应收(元)',
					seleted: true,
					Id: 'UnSettleAmount'
				},
				{
					name: '人均(元/人)',
					seleted: true,
					Id: 'PersonAvgAmount'
				},
				{
					name: '线上(元)',
					seleted: true,
					Id: 'OnlinePayAmount'
				},
				{
					name: '线下(元)',
					seleted: true,
					Id: 'OfllinePayAmount'
				},
				{
					name: '现金流(元)',
					seleted: true,
					Id: 'CashFlow'
				}
			],
		},

		{
			category: '客流',
			categoryId: 2,
			childen: [{
					name: '全部',
					seleted: true,
					Id: 'all'
				},
				{
					name: '在场(人)',
					seleted: true,
					Id: 'Cus_PresentNum'
				},
				{
					name: '进店(人)',
					seleted: true,
					Id: 'Cus_EnterNum'
				},
				{
					name: '离店(人)',
					seleted: true,
					Id: 'Cus_LeaveNum'
				},
				{
					name: '总人数(人)',
					seleted: true,
					Id: 'Cus_TotalNum'
				},
				{
					name: '上班预留(人)',
					seleted: true,
					Id: 'Cus_ReserveNum'
				},
				{
					name: '男宾(人)',
					seleted: true,
					Id: 'Cus_ManNum'
				},
				{
					name: '女宾(人)',
					seleted: true,
					Id: 'Cus_WomanNum'
				},
				{
					name: '儿童(人)',
					seleted: true,
					Id: 'Cus_ChildrenNum'
				},
			],
		},

		{
			category: '会员',
			categoryId: 3,
			childen: [{
					name: '全部',
					seleted: true,
					Id: 'all'
				},
				{
					name: '办卡(张)',
					seleted: true,
					Id: 'Mem_NewcardNum'
				},
				{
					name: '实收(元)',
					seleted: true,
					Id: 'Mem_Receipt'
				},
				{
					name: '消耗(元)',
					seleted: true,
					Id: 'Mem_Consume'
				},
				{
					name: '涨幅(元)',
					seleted: true,
					Id: 'Mem_ReceiptConsumeDiff'
				},
				{
					name: '充值(元)',
					seleted: true,
					Id: 'Mem_RechargeAmount'
				},
				{
					name: '本金(元)',
					seleted: true,
					Id: 'Mem_RechargeReceipt'
				},
				{
					name: '赠送(元)',
					seleted: true,
					Id: 'Mem_RechargeGift'
				},
				{
					name: '续充(元)',
					seleted: true,
					Id: 'Mem_RenewalAmount'
				},
			],
		},
		{
			category: '按摩',
			categoryId: 4,
			childen: [{
					name: '全部',
					seleted: true,
					Id: 'all'
				},
				{
					name: '钟数(个)',
					seleted: true,
					Id: 'Clk_TotalClockCount'
				},
				{
					name: '加钟(个)',
					seleted: true,
					Id: 'Clk_AddClockCount'
				},
				{
					name: '金额(元)',
					seleted: true,
					Id: 'Clk_TotalAmount'
				},
				{
					name: '人数(人)',
					seleted: true,
					Id: 'Clk_PersonCount'
				},
			],
		},

		{
			category: '餐饮',
			categoryId: 5,
			childen: [{
					name: '全部',
					seleted: true,
					Id: 'all'
				},
				{
					name: '人数(人)',
					seleted: true,
					Id: 'Meal_PersonCount'
				},
				{
					name: '金额(元)',
					seleted: true,
					Id: 'Meal_TotalAmount'
				},
				{
					name: '人均(元/人)',
					seleted: true,
					Id: 'Meal_PerConsumeAmount'
				},
				{
					name: '人数占比(%)',
					seleted: true,
					Id: 'Meal_PersonRate'
				},
				{
					name: '翻台率(%)',
					seleted: true,
					Id: 'Meal_TableTurnoverRate'
				},
			],
		},

		{
			category: '客房',
			categoryId: 6,
			childen: [{
					name: '全部',
					seleted: true,
					Id: 'all'
				},
				{
					name: '开房(间)',
					seleted: true,
					Id: 'Room_Count'
				},
				{
					name: '金额(元)',
					seleted: true,
					Id: 'Room_TotalAmount'
				},
				{
					name: '人数占比(%)',
					seleted: true,
					Id: 'Room_PersonRate'
				},
				{
					name: '每间可售房收入(元)',
					seleted: true,
					Id: 'Room_PerIncome'
				},
				{
					name: '平均每日房价(元)',
					seleted: true,
					Id: 'Room_PerDayPrice'
				}, 
				{
					name: '入住率(%)',
					seleted: true,
					Id: 'Room_LiveRate'
				},
				{
					name: '预约数量',
					seleted: true,
					Id: 'Room_BookCount'
				},
				{
					name: '入住数量',
					seleted: true,
					Id: 'Room_CheckInCount'
				},
				{
					name: '在住数量',
					seleted: true,
					Id: 'Room_StayingCount'
				},
			],
		},

		{
			category: '近七日营业额',
			categoryId: 7,
			childen: [{
					name: '全部',
					seleted: true,
					Id: 'all'
				},
				{
					name: '近七日营业额',
					seleted: true,
					Id: 'BusinessDataForDays'
				},

			],
		},

		{
			category: '客源',
			categoryId: 8,
			childen: [{
					name: '全部',
					seleted: true,
					Id: 'all'
				},
				{
					name: '线上线下',
					seleted: true,
					Id: 'PaymentStatisticsItems'
				},
				{
					name: '付款方式',
					seleted: true,
					Id: 'PaymentStatisticsItems2'
				},
			],
		},

		{
			category: '销售排行',
			categoryId: 9,
			childen: [{
					name: '全部',
					seleted: true,
					Id: 'all'
				},
				{
					name: '类别排行',
					seleted: true,
					Id: 'CatalogRankItems'
				},
				{
					name: '菜品排行',
					seleted: true,
					Id: 'GoodsRankItems'
				},
			],
		},

		{
			category: '上钟分析',
			categoryId: 10,
			childen: [{
					name: '全部',
					seleted: true,
					Id: 'all'
				},
				{
					name: '上钟分析',
					seleted: true,
					Id: 'ClockStatisticsDic'
				},
			],
		},

		{
			category: '会员分析',
			categoryId: 11,
			childen: [{
					name: '全部',
					seleted: true,
					Id: 'all'
				},
				{
					name: '合计充值',
					seleted: true,
					Id: "TotalRechange"
				},
				{
					name: '合计消耗',
					seleted: true,
					Id: "TotalConume"
				},
				{
					name: '新签',
					seleted: true,
					Id: 'New'
				},
				{
					name: '续签',
					seleted: true,
					Id: 'ReChange'
				},
				{
					name: '消耗',
					seleted: true,
					Id: "Consume"
				},
				
			],
		},
		{
			category: '充值消耗(元)',
			categoryId: 12,
			childen: [{
					name: '全部',
					seleted: true,
					Id: 'all'
				},
				{
					name: '充值消耗(元)',
					seleted: true,
					Id: "MmberRechangeConsume"
				},
				{
					name: '新签续充(张)',
					seleted: true,
					Id: "MmberNewAddRechange"
				},
			],
		},
	]
	const jsonString = handleLocalStorage.get('ReportConfi');
	if (!jsonString || (jsonString + '').length < 3000) {
		handleLocalStorage.set('ReportConfi', JSON.stringify(result))
	} 
	return result
}
